import React, { useState, useRef } from "react";
import { MdOutlineComputer, MdPhoneIphone } from "react-icons/md";
import PCView from "./PCView";
import PhoneView from "./PhoneView";
import { TbGalaxy } from "react-icons/tb";

const Preview = ({ hasPreview, previewUrl, reloadPrev }) => {
  const [view, setView] = useState("pc");


  return (
    <>


      <div className="preview_main_container">
        <div className="preview_main_container_header">
          <div className="preview_main_container_header_inner">
            <div
              className="preview_main_container_header_inner_btn"
              onClick={() => setView("pc")}
            >
              <span>
                <MdOutlineComputer />
              </span>
            </div>
            <div
              className="preview_main_container_header_inner_btn"
              onClick={() => setView("phone")}
            >
              <span>
                <MdPhoneIphone />
              </span>
            </div>
          </div>
        </div>

        <div className="preview_main_container_body">
          {false ? (
            <div className="loading_fetch_preview">
              <div className="loading_logo_erioon">
                <p className="loading_logo_erioon_icon">
                  <i>
                    <TbGalaxy />
                  </i>
                </p>
              </div>
            </div>
          ) : (
            <>
              {hasPreview ? (
                view === "pc" ? (
                  <PCView previewUrl={previewUrl} reloadPrev={reloadPrev}/>
                ) : (
                  <PhoneView previewUrl={previewUrl} reloadPrev={reloadPrev}/>
                )
              ) : (
                <div className="preview_main_container_body_empty">
                  <p className="preview_main_container_body_empty_title">No preview available yet</p>
                  <p className="preview_main_container_body_empty_desc">
                    Once you publish your project, a live preview will appear here.
                  </p>

                  <div className="preview_canvas_cont">
                    <div className="preview_items_cont">
                      <div className="preview_items_cont_item_one"></div>
                      <div className="preview_items_cont_item_two">
                        <div className="preview_items_cont_item_three"></div>
                        <div className="preview_items_cont_item_four">
                          <div className="preview_items_cont_item_five"></div>
                          <div className="preview_items_cont_item_five"></div>

                        </div>
                      </div>
                      <div className="preview_items_cont_item_one"></div>
                    </div>
                  </div>
                  {/* <button className="publish_btn">Open instant preview</button> */}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Preview;
